import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { addBo, logout, loadInspectionsList } from './../../actions/actions';
import InputLabel from '@material-ui/core/InputLabel';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import Header from './../../components/Header';
import Footer from './../../components/Footer';
import { bo_attributes as attributes, roles }  from './../../helpers/trans';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import 'moment/locale/ru';
import { DatePicker } from 'material-ui-pickers';
import Typography from '@material-ui/core/Typography';
import OldBrowserMessage from './../OldBrowserMessage';
import SelectInspections from './../controls/SelectInspections';

const fields_array = [
    'registration_number',
    'registration_date',
    'development_start_date',
    'development_finish_date',
    'client_org_name',
    'client_org_country',
    'client_org_state',
    'client_org_region',
    'client_org_city',
    'client_org_street',
    'client_org_phone',
    'client_org_email',
    'client_org_website',
    'client_org_responsible',
    'object_name',
    'object_country',
    'object_state',
    'object_region',
    'object_city',
    'object_street',
    'object_block',
    'object_building',
    'object_address_approximate',
    'object_address_lon',
    'object_address_lat',
    'design_company_name',
    'design_company_country',
    'design_company_state',
    'design_company_region',
    'design_company_city',
    'design_company_street',
    'design_company_email',
    'design_website',
    'design_responsible',
    'developer_name',
    'developer_country',
    'developer_state',
    'developer_region',
    'developer_city',
    'developer_street',
    'developer_phone',
    'developer_email',
    'developer_website',
    'developer_responsible',
    'supervision_name',
    'supervision_country',
    'supervision_state',
    'supervision_region',
    'supervision_city',
    'supervision_street',
    'supervision_phone',
    'supervision_email',
    'supervision_website',
    'supervision_responsible',
    'author_supervision_name',
    'author_supervision_country',
    'author_supervision_state',
    'author_supervision_region',
    'author_supervision_city',
    'author_supervision_street',
    'author_supervision_website',
    'author_supervision_responsible',
    'state',
    'curator',
    'category'
]

export class ObjectsPage extends React.Component{
      constructor(props){
          super(props);
          this.state = {
              auth: false,
              user:{},
              message:'',
              status:'',
              object_form: {
                  registration_number:'',
                  registration_date: null,
                  development_start_date: null,
                  development_finish_date: null,
                  client_org_name:'',
                  client_org_country:'',
                  client_org_state:'',
                  client_org_region:'',
                  client_org_city:'',
                  client_org_street:'',
                  client_org_phone:'',
                  client_org_email:'',
                  client_org_website:'',
                  client_org_responsible:'',
                  inspection_id: null,
                  object_name:'',
                  object_country:'',
                  object_state:'',
                  object_region:'',
                  object_city:'',
                  object_street:'',
                  object_block:'',
                  object_building:'',
                  object_address_approximate:'',
                  object_address_lon:'',
                  object_address_lat:'',
                 // org_id:'',
                  design_company_name:'',
                  design_company_country:'',
                  design_company_state:'',
                  design_company_region:'',
                  design_company_city:'',
                  design_company_street:'',
                  design_company_email:'',
                  design_website:'',
                  design_responsible:'',
                  developer_name:'',
                  developer_country:'',
                  developer_state:'',
                  developer_region:'',
                  developer_city:'',
                  developer_street:'',
                  developer_phone:'',
                  developer_email:'',
                  developer_website:'',
                  developer_responsible:'',
                  supervision_name:'',
                  supervision_country:'',
                  supervision_state:'',
                  supervision_region:'',
                  supervision_city:'',
                  supervision_street:'',
                  supervision_phone:'',
                  supervision_email:'',
                  supervision_website:'',
                  supervision_responsible:'',
                  author_supervision_name:'',
                  author_supervision_country:'',
                  author_supervision_state:'',
                  author_supervision_region:'',
                  author_supervision_city:'',
                  author_supervision_street:'',
                  author_supervision_website:'',
                  author_supervision_responsible:'',
                  state:'',
                  curator:'',
                  category:''
              }
          }
      }

    logout = () => {
        this.props.logout();
        this.setState({auth:false, user:{}, redirect:null});
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if( user !== null ){
            if (
                user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0|| 
                user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0|| 
                user.role.indexOf(roles.ROLE_SUPERVISOR)>=0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_APPEALS)>=0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE)>=0 ||
                user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES)>=0 ||
                user.role.indexOf('ROLE_INSPECTOR_OBJECTS')>=0
             ) {
                this.setState({auth: true, user: user});
            }
        }
        if (this.props.inspections.length == 0 && (user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0||
            user.role.indexOf(roles.ROLE_SUPERVISOR)>=0)) {
            this.props.loadInspections(user.token);
        }

    }

    handleDateChange = name => date => {
        console.log(date);
        console.log(name);
        let value = date.toISOString().split('T')[0];
        console.log(value);
        let data = {[name]: value } ;
        let currentData = this.state.object_form;
        this.setState({object_form:{ ...currentData, ...data}});
    };


    handleSaveObject = () => {
        console.log(this.state.object_form);
        this.props.addBo(this.state.object_form, this.state.user.token);
    }

    updateInput = input => {
        let data = {[input.name]: input.value } ;
        let currentData = this.state.object_form;
        this.setState({ object_form:{ ...currentData, ...data}});
    };

    onSelect = event => {
        this.setState({ object_form: { ...this.state.object_form, ...{ inspection_id: event.target.value}}});
    }

      render(){
          if (this.state.auth == false) {
              return (<Redirect to="/login"/>)
          }
          let textInputs = fields_array.map(
              (item) =>
                  (<Typography component="div">
              {(item == 'registration_date'|| item == 'development_start_date' || item == 'development_finish_date') &&
              (<DatePicker onChange={this.handleDateChange(item)}
                           label={attributes[item]}
                           fullWidth
                           format='DD.MM.YYYY'
                           id={item}
                           key={item}
                           name={item}
                           value={this.state.object_form[item]}
                           InputLabelProps={{ shrink: true,  }}

              ></DatePicker>)}

          {(item !== 'registration_date'&& item !== 'development_start_date' && item !== 'development_finish_date') &&
          (<TextField
              onChange={e => this.updateInput(e.target)}
              label={attributes[item]}
              fullWidth
              key={item}
              id={item}
              name={item}
              margin="normal"
              value={this.state.object_form[item]}
              InputLabelProps={{ shrink: true,}}
          />)}
                  </Typography>)
                  );
          return (
              <div>
                  {(this.state.user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 || this.state.user.role.indexOf('ROLE_INSPECTOR_OBJECTS')>=0) &&(<Header link={{to:'/inspection/', title: this.state.user.org}} />)}
                  {this.state.user.role.indexOf(roles.ROLE_SUPERVISOR)>=0 && (<Header link={{to:'/supervision/', title: this.state.user.org}} />)}
                  {this.state.user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0 && (<Header link={{to:'/admin/', title: this.state.user.org}} />)}
                  {(this.state.user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 || this.state.user.role.indexOf('ROLE_INSPECTOR_OBJECTS')>=0) && (
                  <Toolbar>
                      <Button component={Link} to="/inspection/">Вернуться</Button>
                      <Button component={Link} to="/inspection-objects">Поднадзорные объекты</Button>
                      {/*<Button component={Link} to="/inspection-appeals">Электронные обращения</Button>*/}
                      <Button onClick={this.logout}>Выйти</Button>
                  </Toolbar>)}
                  {this.state.user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0 && (
                   <Toolbar>
                      <Button component={Link} to="/admin/">Вернуться</Button>
                      <Button onClick={this.logout}>Выйти</Button>
                  </Toolbar>)}
                  {(this.state.user.role.indexOf(roles.ROLE_SUPERVISOR)>=0 )&& (
                      <Toolbar>
                          <Button component={Link} to="/supervision/">Вернуться</Button>
                          <Button onClick={this.logout}>Выйти</Button>
                      </Toolbar>)}
                  <Paper style={{ padding:"2em" }}>
                  <OldBrowserMessage />
                  <form>{(this.state.user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0||
                  this.state.user.role.indexOf(roles.ROLE_SUPERVISOR)>=0)&&(
                      <div>
                      <InputLabel style={{fontSize:'0.8em',marginLeft:'0.2em'}} htmlFor="reg-insp-select" >{ attributes['inspection_name']}</InputLabel>
                      <SelectInspections id="reg-insp-select"
                                         name="inspection_id"
                                         onChange={ this.onSelect }
                                         items={ this.props.inspections }
                                         value={ this.state.object_form.inspection_id }/></div>)}
                  {textInputs}
                  <Button onClick={this.handleSaveObject}>Сохранить</Button>
                  <h1>{this.state.message}</h1>
                  </form>
                  </Paper>
                  <Footer />
                  </div>

          );
      }

    componentWillReceiveProps(nextProps) {
        this.setState({ message: nextProps.message});
    }

}

ObjectsPage.defaultProps = {
    inspections:[],
    redirect: null
}

function select(state, props) {
    const { admin, message, notifications } = state;
    console.log(admin);
    return {
         message: admin.message ,
         inspections: ('inspections' in notifications) ? notifications.inspections: [],
        // fetching: notification.fetching || false,
        // response_status: notification.response_status || ''
    };
}


function mapDispatch(dispatch) {
    return {
        addBo: bindActionCreators(addBo, dispatch) ,
        logout: bindActionCreators(logout, dispatch),
        loadInspections: bindActionCreators(loadInspectionsList, dispatch)
    };
}

export default connect(select, mapDispatch)(ObjectsPage);





// WEBPACK FOOTER //
// ./assets/src/js/components/pages/ObjectsPage.jsx